import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import http from 'hub-http/clients/apiClient';
import { convertMultiLangCategoriesToOldFormat, convertMultiLangEditResponseToOldFormat, getKnowledgeBaseIdIsOnSCP } from '../migration-handler/singleton/migrationHandler';
import { makeSimpleQuickFetchWrapper } from '../utils/ajaxUtils';
const API_BASE = '/knowledge-content/v1/knowledge-category-translations';
const CATEGORY_API_BASE = '/knowledge-content/v1/knowledge-categories';
const SCP_API_BASE = 'knowledge-content/v2/category-organization/knowledge-base';
const SCP_CATEGORY_API_BASE = 'knowledge-content/v2/category';
export default class MultiLanguageCategoriesApi {
  static createMultiLanguage(parentCategoryId, categoryTranslations, knowledgeBaseId, primaryLanguage, homepageSettings) {
    const isOnSCP = getKnowledgeBaseIdIsOnSCP(knowledgeBaseId);
    if (!isOnSCP) {
      const data = {
        parentCategoryId,
        knowledgeCategoryTranslations: categoryTranslations,
        knowledgeBaseId
      };
      return http.post(`${CATEGORY_API_BASE}`, {
        data
      });
    }
    const {
        [primaryLanguage]: primary
      } = categoryTranslations,
      restTranslations = _objectWithoutPropertiesLoose(categoryTranslations, [primaryLanguage].map(_toPropertyKey));

    //on SCP homepageSettings will be required
    const data = {
      knowledgeBaseId,
      name: primary.name,
      description: primary.description,
      color: homepageSettings && homepageSettings.color,
      iconName: homepageSettings && homepageSettings.iconName,
      iconType: homepageSettings && homepageSettings.iconType,
      iconUnicode: homepageSettings && homepageSettings.iconUnicode,
      imageSrc: homepageSettings && homepageSettings.imageSrc,
      imageTypeEnum: homepageSettings && homepageSettings.imageTypeEnum,
      isDisplayed: homepageSettings && homepageSettings.isDisplayed,
      translations: restTranslations,
      parentCategoryId
    };
    return http.post(`${SCP_CATEGORY_API_BASE}/translation`, {
      data
    });
  }
  static updateCategoryTranslations(category, knowledgeBaseId, selectedSubcategoryId) {
    const isOnSCP = getKnowledgeBaseIdIsOnSCP(knowledgeBaseId);
    if (!isOnSCP) {
      const subcategories = category.subcategories.map(subcategory => ({
        knowledgeCategoryId: subcategory.id,
        translations: subcategory.nameTranslations
      }));
      const data = [{
        knowledgeCategoryId: category.knowledgeCategoryId,
        translations: category.nameTranslations
      }, ...subcategories];
      return http.put(`${API_BASE}/categories-translations`, {
        data
      });
    }
    const editedCategoryOrSubcategory = selectedSubcategoryId ? category.subcategories.find(subcategory => {
      return subcategory.id === Number(selectedSubcategoryId);
    }) : category;
    const primaryTranslation = editedCategoryOrSubcategory.nameTranslations.find(translation => translation.language === editedCategoryOrSubcategory.language);
    const data = {
      knowledgeBaseId,
      name: primaryTranslation.name,
      description: primaryTranslation.description,
      articleIds: editedCategoryOrSubcategory.articleIds,
      color: editedCategoryOrSubcategory.color,
      iconName: editedCategoryOrSubcategory.iconName,
      iconType: editedCategoryOrSubcategory.iconType,
      iconUnicode: editedCategoryOrSubcategory.iconUnicode,
      imageSrc: editedCategoryOrSubcategory.imageSrc,
      imageTypeEnum: editedCategoryOrSubcategory.imageTypeEnum,
      isDisplayed: editedCategoryOrSubcategory.isDisplayed,
      position: editedCategoryOrSubcategory.position,
      translations: editedCategoryOrSubcategory.nameTranslations.reduce((acc, translation) => {
        if (translation.language !== primaryTranslation.language) {
          acc[translation.language] = {
            id: translation.id,
            name: translation.name,
            description: translation.description,
            language: translation.language
          };
        }
        return acc;
      }, {})
    };
    return http.put(`${SCP_CATEGORY_API_BASE}/translation/${editedCategoryOrSubcategory.id}`, {
      data
    }).then(response => {
      return {
        categories: convertMultiLangEditResponseToOldFormat([response]),
        primaryLanguage: category.language,
        requestedLanguages: Object.keys(data.translations)
      };
    });
  }
  static getCategory(categoryId) {
    return http.get(`${SCP_CATEGORY_API_BASE}/${categoryId}`);
  }
}
MultiLanguageCategoriesApi.getMultiLanguageCategories = makeSimpleQuickFetchWrapper(({
  knowledgeBaseId
}) => `get-categories-translations-${knowledgeBaseId}`, ({
  languages,
  includeDescriptions = false,
  includeArticles = false,
  knowledgeBaseId
}) => {
  const isOnSCP = getKnowledgeBaseIdIsOnSCP(knowledgeBaseId);
  if (!isOnSCP) {
    return http.get(`${API_BASE}/categories-translations`, {
      query: {
        language: languages,
        includeDescriptions,
        includeArticles,
        knowledgeBaseId
      }
    });
  }
  return http.get(`${SCP_API_BASE}/${knowledgeBaseId}`, {
    query: {
      language: languages
    }
  }).then(response => ({
    categories: convertMultiLangCategoriesToOldFormat(response.categories),
    primaryLanguage: response.primaryLanguage,
    requestedLanguages: [response.requestedLanguage]
  }));
});